<div class="multi-line-cell" (click)="$event.stopPropagation()">
  <div class="p-1" *ngFor="let item of visibleItems; trackBy: trackByIndex">
    <button
      *ngIf="action && (!action.isVisible || action.isVisible(item, params))"
      type="button"
      class="btn btn-xs me-2"
      [ngClass]="getButtonClass(item)"
      [disabled]="action.isDisabled?.(item, params) ?? false"
      (click)="clickAction(item, $event)"
    >
      <i *ngIf="action.iconClass" [class]="action.iconClass"></i>
    </button>

    <span [ngClass]="getTextClass(item)">
      {{ item.text }}
    </span>
  </div>

  <button
    *ngIf="items.length > maxVisible"
    type="button"
    class="btn btn-sm btn-link px-0 align-self-start"
    (click)="toggleShowAll($event)"
  >
    <span *ngIf="!showAll">
      <i class="fa-solid fa-chevron-down"></i>
      ({{ items.length }})
      {{ "shared.grid.multiline.showAll" | transloco }}
    </span>

    <span *ngIf="showAll">
      <i class="fa-solid fa-chevron-up"></i>
      {{ "shared.grid.multiline.showLess" | transloco }}
    </span>
  </button>
</div>
